const StorageService = {
  setItem: (key, value) => {
    localStorage.setItem(key, JSON.stringify(value));
  },

getItem: (key) => {
  const value = localStorage.getItem(key);
  try {
    return value ? JSON.parse(value) : null;
  } catch (e) {
    console.warn(`StorageService: Failed to parse value for key "${key}"`);
    return null;
  }
},

  removeItem: (key) => {
    localStorage.removeItem(key);
  },

  clearAll: () => {
    localStorage.clear();
  },
};

export default StorageService;
